var _path, _rect, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCohortTooltipLtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 20,
    viewBox: "0 0 376 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.936 5.504V14H1.92V7.592H2.016L4.632 14H5.568L8.208 7.592H8.304V14H9.288V5.504H8.016L5.16 12.488H5.064L2.208 5.504H0.936ZM11.0107 14H12.0428V7.64H11.0107V14ZM10.8188 5.912C10.8188 6.284 11.1428 6.584 11.5388 6.584C11.9228 6.584 12.2468 6.284 12.2348 5.912C12.2468 5.54 11.9228 5.24 11.5388 5.24C11.1428 5.24 10.8188 5.54 10.8188 5.912ZM14.656 10.184C14.644 9.08 15.328 8.456 16.264 8.456C17.152 8.456 17.692 9.044 17.704 10.04V14H18.712V9.944C18.712 8.336 17.848 7.556 16.552 7.544C15.592 7.556 14.992 7.988 14.704 8.648H14.608V7.64H13.624V14H14.656V10.184Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 2.5,
    width: 327,
    height: 15,
    rx: 4,
    fill: "url(#paint0_linear_2803_4142)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.936 5.504V14H354.92V7.592H355.016L357.632 14H358.568L361.208 7.592H361.304V14H362.288V5.504H361.016L358.16 12.488H358.064L355.208 5.504H353.936ZM363.723 12.2C363.723 13.436 364.683 14.144 365.907 14.144C366.999 14.144 367.575 13.556 367.779 13.136H367.827V14H368.835V9.8C368.835 7.796 367.275 7.556 366.435 7.544C365.031 7.556 364.035 8.264 363.915 9.296H364.971C365.103 8.804 365.595 8.432 366.387 8.432C367.359 8.432 367.839 8.9 367.827 9.704V10.232C367.539 10.232 366.531 10.292 366.123 10.328C365.007 10.4 363.723 10.736 363.723 12.2ZM364.731 12.248C364.731 11.552 365.319 11.228 366.243 11.168L367.827 11.048V11.696C367.839 12.488 367.203 13.256 366.051 13.256C365.295 13.256 364.731 12.92 364.731 12.248ZM371.212 7.64H370.06L372.076 10.808L370.06 14H371.212L372.724 11.528L374.236 14H375.388L373.348 10.808L375.388 7.64H374.236L372.724 10.232L371.212 7.64Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2803_4142",
    x1: 23,
    y1: 17.5,
    x2: 350,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0DFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513021,
    stopColor: "#362EF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060073"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortTooltipLtv);
export default __webpack_public_path__ + "static/media/cohort_tooltip_ltv.cac98a40ed8e006b9c32ef6685a7b065.svg";
export { ForwardRef as ReactComponent };